import axios from "axios";
import { msalService } from "@/config/useAuth";

const auth = msalService()

const backEndUrl = window.env.VUE_APP_API_URL

const axiosInstance = axios.create({
  validateStatus: () => true,
  maxRedirects: 0,
});
// Pull a human-readable message out of an error response body. The API returns
// either a plain string (e.g. a Conflict message) or an ASP.NET ProblemDetails
// object. Returns null when there's nothing useful to show.
function extractServerMessage(data) {
  if (!data) return null;
  if (typeof data === "string") return data.trim() || null;
  if (typeof data === "object") {
    if (data.errors && typeof data.errors === "object") {
      const messages = Object.values(data.errors).flat().filter(Boolean);
      if (messages.length) return messages.join(" ");
    }
    return data.detail || data.title || data.message || null;
  }
  return null;
}

export async function callAPI(method, url, data = null, { strict = true } = {}) {
  try {
    const accessToken = await auth.getToken();

    const options = {
      method,
      url: `${backEndUrl}${url}`,
      headers: {
        "Content-Type": "application/json",
        "Accept": "*/*",
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
      data,
    };

    const response = await axiosInstance(options);

    if (response.status >= 200 && response.status < 300) {
      return response.data;
    }

    console.error(`API Error (${method} ${url}):`, response.data);
    if (!strict) return null;

    const serverMessage = extractServerMessage(response.data);
    const isClientError = response.status >= 400 && response.status < 500;
    // Surface the server's own message for client errors (400/404/409 ...).
    // For 5xx we deliberately hide the body — it can contain raw exception
    // text — and leave the message blank so callers fall back to their own
    // friendly copy.
    const err = new Error(isClientError && serverMessage ? serverMessage : "");
    err.status = response.status;
    err.serverMessage = serverMessage;
    throw err;
  } catch (error) {
    if (strict) throw error;
    return null;
  }
}